/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B030070 得意先元帳照会
 */
import { Column, Query } from "@material-table/core";
import {
  SText,
  SCodeSelect,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  STextField,
  msgState,
} from "components";
import { B030070TorihikisakiKbn, getSCode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { createRef, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { focusState, navigateTypeState, useFocus } from "states";
import { dateWithSlashAt, mapIds, yearMonth } from "../../services";
import { B000150, B020010InputData, B030050InputData } from "pages";
import {
  B000150TokuiNmrUrikakeCd,
  B020020Get,
  catchRestError,
} from "clients/rest";
import { useNavigate } from "react-router-dom";
import {
  B030070Find,
  B030070Request,
  B030070FindResponse,
} from "clients/rest/b030/B030070";
import { editKbn, uriageNyukinCheckKbn } from "services/codes";
import { B030050Find } from "clients/rest/b030/B030050";

// TODO 画面遷移処理

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// 検索条件を格納するデータタイプ
type SearchedFields = {
  searched: boolean;
} & Partial<{
  fields: Fields;
  page: number;
  pageSize: number;
  sort: string[];
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  // 検索ヘッダー部(条件)
  urikakeYm: string;
  torihikiKbn: SCode;
  urikakeCd: string;
  urikakeshitenCd: string;
  tokuiNmr: string;
  // 検索ヘッダー部
  shainCd: string;
  shainNm: string;
  telNo: string;
  faxNo: string;
  shimeD: string;
  kaishuyoteiD: string;
  kaishuKbn: string;
  tokuibunNm1: string;
  tokuibunNm2: string;
  tokuibunNm3: string;
  tokuibunNm4: string;
  tokuibunNm5: string;
}>;

// 集計部(売掛)
export type ShukeiFields = Partial<{
  urikakeYm: string;
  zenzanKin: string;
  konkainyuKin: string;
  konkaiuriKin: string;
  henpinnebikiKin: string;
  sotozeiKin: string;
  uchizeiKin: string;
  urikakezanKin: string;
  genkinnyuKin: string;
  furikominyuKin: string;
  tegatanyuKin: string;
  kogitenyuKin: string;
  sosainyuKin: string;
  nebikinyuKin: string;
  tesuryoKin: string;
  sonotanyuKin: string;
  headerUriKin: string;
  henpinKin: string;
  nebikiKin: string;
  sonotauriKin: string;
}>;

// テーブルデータ定義
type Data = Partial<{
  gyoNo: string;
  denpyoYmd: string;
  denpyoNo: string;
  denpyogyoNo: string;
  torihikiKbn: string;
  chumonNo: string;
  chohaKbn: string;
  uchiwakeNm: string;
  shohinCd: string;
  shohinNm: string;
  urisu: string;
  uritanka: string;
  uriKin: string;
  zeiKin: string;
  nyuKin: string;
  meisaibiko: string;
  seikyuNmr: string;
  tokuiNmr: string;
  sonotauriKin: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  // 検索ヘッダー部(条件)
  urikakeYm: yearMonth(),
  torihikiKbn: getSCode(B030070TorihikisakiKbn, "2"),
  urikakeCd: "",
  urikakeshitenCd: "",
  tokuiNmr: "",
  // 検索ヘッダー部
  shainCd: "",
  shainNm: "",
  telNo: "",
  faxNo: "",
  shimeD: "",
  kaishuyoteiD: "",
  kaishuKbn: "",
  tokuibunNm1: "",
  tokuibunNm2: "",
  tokuibunNm3: "",
  tokuibunNm4: "",
  tokuibunNm5: "",
};

const defaultShukeiFields: ShukeiFields = {
  urikakeYm: "",
  zenzanKin: "",
  konkainyuKin: "",
  konkaiuriKin: "",
  henpinnebikiKin: "",
  sotozeiKin: "",
  uchizeiKin: "",
  urikakezanKin: "",
  genkinnyuKin: "",
  furikominyuKin: "",
  tegatanyuKin: "",
  kogitenyuKin: "",
  sosainyuKin: "",
  nebikinyuKin: "",
  tesuryoKin: "",
  sonotanyuKin: "",
  headerUriKin: "",
  henpinKin: "",
  nebikiKin: "",
  sonotauriKin: "",
};

// テーブルを定義する。
const columns: Column<Data>[] = [
  { field: "gyoNo", title: "行　", width: "3rem", align: "right" },
  {
    field: "denpyoYmd",
    title: "伝票日付",
    width: "6rem",
    render: (data) => dateWithSlashAt(data.denpyoYmd! ?? ""),
  },
  { field: "denpyoNo", title: "伝票No", width: "6rem" },
  { field: "denpyogyoNo", title: "伝票 行 No", hidden: true },
  { field: "torihikiKbn", title: "取引区分", width: "4rem" },
  { field: "chumonNo", title: "注文No.", width: "6rem" },
  { field: "chohaKbn", title: "売上区分", width: "6rem" },
  { field: "uchiwakeNm", title: "区分", width: "6rem" },
  { field: "shohinCd", title: "商品コード", width: "8rem" },
  { field: "shohinNm", title: "商品名", width: "20rem" },
  { field: "urisu", title: "数量　", width: "4rem", align: "right" },
  {
    field: "uritanka",
    title: "売上単価　",
    width: "6rem",
    align: "right",
    render: (data) => data.uritanka?.toLocaleString(),
  },
  {
    field: "uriKin",
    title: "売上額　",
    width: "8rem",
    align: "right",
    render: (data) => data.uriKin?.toLocaleString(),
  },
  {
    field: "zeiKin",
    title: "消費税　",
    width: "6rem",
    align: "right",
    render: (data) => data.zeiKin?.toLocaleString(),
  },
  {
    field: "nyuKin",
    title: "入金額　",
    width: "8rem",
    align: "right",
    render: (data) => data.nyuKin?.toLocaleString(),
  },
  { field: "meisaibiko", title: "明細備考", width: "12rem" },
  { field: "seikyuNmr", title: "請求先名", width: "10rem" },
  { field: "tokuiNmr", title: "得意先名", width: "10rem" },
];

const focusId = "B030070";

// B030070 得意先元帳照会
export const B030070 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

// 検索条件を格納するステート
const B030070State = atom<SearchedFields>({
  key: "B030070State",
  default: {
    searched: false,
    fields: defaultFields,
  },
});

const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();
  // 初回検索用のフラグ
  const [searched, setSearched] = useState(false);
  // 検索ボタン押下時に初期ページにするRef
  const isDefaultPage = useRef(false);
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  const shukeiMethods = useForm<ShukeiFields>({
    mode: "onBlur",
    defaultValues: defaultShukeiFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移の処理
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);
  // メッセージ表示
  const setMsg = useSetRecoilState(msgState);
  // テーブル行で選択されたデータ
  const [rowData, setRowData] = useState<Partial<Data>>();
  // 詳細ボタン活性制御
  const [disabledDetailButton, setDisabledDetailButton] = useState(true);
  // 検索条件フィールドの定義
  const [searchedFields, setSearchedFields] = useRecoilState(B030070State);

  // 初期表示イベント
  useEffect(() => {
    if (menuNavigate === "prev") {
      // 検索条件が保存されている
      if (searchedFields.searched) {
        const fields = searchedFields.fields;
        if (typeof fields !== "undefined") {
          methods.setValue("urikakeYm", fields.urikakeYm ?? "");
          methods.setValue("torihikiKbn", fields.torihikiKbn ?? null);
          methods.setValue("urikakeCd", fields.urikakeCd ?? "");
          methods.setValue("urikakeshitenCd", fields.urikakeshitenCd ?? "");
          methods.setValue("tokuiNmr", fields.tokuiNmr ?? "");
          setSearched(true);
          return;
        }
      }
    }

    focus(1);
  }, []);

  // 検索ボタンクリックイベント
  const handleClickSearchButton = () => {
    // 初期化
    handleResetSearch();
    // 検索可能に変更
    setSearched(true);
    // 初期ページ設定
    isDefaultPage.current = true;
    // テーブル再検索
    (tableRef.current as any).onQueryChange();
  };

  // 検索時の初期化処理
  const handleResetSearch = () => {
    // 検索実行時、選択行の解除と各ボタンの非活性化
    setRowData(undefined);
    setDisabledDetailButton(true);
    (tableRef.current as any).handleClearSelect();
  };

  // 検索イベント
  const handleSearch = (query: Query<Data>) => {
    return new Promise<any>((resolve) => {
      // 初回検索をしない
      if (!searched) {
        resolve({
          data: [],
          page: 0,
          totalCount: 0,
        });
        return;
      }

      // 検索フォームのデータを取得する。
      const fields = methods.getValues();

      // 初期ページ表示の場合、0を設定する。
      query.page = isDefaultPage.current ? 0 : query.page;

      // 検索パラメータを作成する。
      const param: B030070Request = {
        urikakeYm: fields.urikakeYm!,
        torihikiKbn: fields.torihikiKbn?.value!,
        urikakeCd: fields.urikakeCd!,
        urikakeshitenCd: fields.urikakeshitenCd!,
        // ページネーションの設定
        page: query.page,
        size: query.pageSize,
        // ソートの設定
        sort: [
          "urikakeCd,asc",
          "seikyuCd,asc",
          "tokuiCd,asc",
          "denpyoYmd,asc",
          "denpyoNo,asc",
        ],
      };
      // API呼び出し
      B030070Find(param)
        // 正常取得時
        .then((value) => {
          // 集計部分の設定
          handleAggregate(value.data.content[0], value.data.totalElements);

          const offset = query.pageSize * query.page;

          if (!value.data.content[0].denpyoNo) {
            resolve({
              data: [],
              page: 0,
              totalCount: 0,
            });
            return;
          }
          resolve({
            data: mapIds(value.data.content, "gyoNo", offset),
            page: value.data.number,
            totalCount: value.data.totalElements,
          });
        })
        // エラー時
        .catch((reason) => {
          // エラー時は集計部分をクリアする。
          shukeiMethods.reset();
          // 詳細ボタン非活性化
          setDisabledDetailButton(true);

          catchRestError(reason, navigate, setMsg);
          resolve({
            data: [],
            page: 0,
            totalCount: 0,
          });
        })
        .finally(() => {
          // 初期ページ表示をオフにする。
          isDefaultPage.current = false;
        });
    });
  };

  // ヘッダ部分・集計部分の設定
  const handleAggregate = (
    data: B030070FindResponse,
    totalElements: number
  ) => {
    // 検索結果が存在するかチェック
    if (totalElements === 0) {
      // データ非存在メッセージ表示
      setMsg("指定された検索条件に合致するデータは存在しません。");
      // 結果なしの場合、ヘッダ部の表示項目削除
      methods.setValue("shainCd", "");
      methods.setValue("shainNm", "");
      methods.setValue("telNo", "");
      methods.setValue("faxNo", "");
      methods.setValue("shimeD", "");
      methods.setValue("kaishuyoteiD", "");
      methods.setValue("kaishuKbn", "");
      methods.setValue("tokuibunNm1", "");
      methods.setValue("tokuibunNm2", "");
      methods.setValue("tokuibunNm3", "");
      methods.setValue("tokuibunNm4", "");
      methods.setValue("tokuibunNm5", "");
      // 結果なしの場合、集計部分クリア
      shukeiMethods.reset();
    }
    // 結果が1件以上取得できた場合
    else {
      // ヘッダ部分の設定
      methods.setValue("shainCd", data.shainCd ?? "");
      methods.setValue("shainNm", data.shainNm ?? "");
      methods.setValue("telNo", data.telNo ?? "");
      methods.setValue("faxNo", data.faxNo ?? "");
      methods.setValue("shimeD", data.shimeD ?? "");
      methods.setValue("kaishuyoteiD", data.kaishuyoteiD ?? "");
      methods.setValue("kaishuKbn", data.kaishuKbn ?? "");
      methods.setValue("tokuibunNm1", data.tokuibunNm1 ?? "");
      methods.setValue("tokuibunNm2", data.tokuibunNm2 ?? "");
      methods.setValue("tokuibunNm3", data.tokuibunNm3 ?? "");
      methods.setValue("tokuibunNm4", data.tokuibunNm4 ?? "");
      methods.setValue("tokuibunNm5", data.tokuibunNm5 ?? "");
      // 集計部分の設定
      shukeiMethods.setValue("zenzanKin", data.zenzanKin ?? "");
      shukeiMethods.setValue("konkainyuKin", data.konkainyuKin ?? "");
      shukeiMethods.setValue("konkaiuriKin", data.konkaiuriKin ?? "");
      shukeiMethods.setValue("henpinnebikiKin", data.henpinnebikiKin ?? "");
      shukeiMethods.setValue("sotozeiKin", data.sotozeiKin ?? "");
      shukeiMethods.setValue("uchizeiKin", data.uchizeiKin ?? "");
      shukeiMethods.setValue("urikakezanKin", data.urikakezanKin ?? "");
      shukeiMethods.setValue("genkinnyuKin", data.genkinnyuKin ?? "");
      shukeiMethods.setValue("furikominyuKin", data.furikominyuKin ?? "");
      shukeiMethods.setValue("tegatanyuKin", data.tegatanyuKin ?? "");
      shukeiMethods.setValue("kogitenyuKin", data.kogitenyuKin ?? "");
      shukeiMethods.setValue("sosainyuKin", data.sosainyuKin ?? "");
      shukeiMethods.setValue("nebikinyuKin", data.nebikinyuKin ?? "");
      shukeiMethods.setValue("tesuryoKin", data.tesuryoKin ?? "");
      shukeiMethods.setValue("sonotanyuKin", data.sonotanyuKin ?? "");
      shukeiMethods.setValue("headerUriKin", data.headerUriKin ?? "");
      shukeiMethods.setValue("henpinKin", data.henpinKin ?? "");
      shukeiMethods.setValue("nebikiKin", data.nebikiKin ?? "");
      shukeiMethods.setValue("sonotauriKin", data.sonotauriKin ?? "");
    }
  };

  // テーブル行ダブルクリック/詳細ボタンクリックイベント
  const handleShowDatail = () => {
    if (typeof rowData === "undefined") {
      return;
    }
    // 売上区分をチェック
    if (rowData.torihikiKbn === uriageNyukinCheckKbn.uriage) {
      // 売上入力(参照モード)画面への遷移処理
      handleUriageNavigate();
    } else if (rowData.torihikiKbn === uriageNyukinCheckKbn.nyukin) {
      // 入金入力画面への遷移処理
      handleNyukinNavigate();
    }
  };

  // 売上入力(参照モード)画面への遷移処理
  const handleUriageNavigate = () => {
    // 売上データの検索を行う
    B020020Get({ uridenpyoNo: rowData?.denpyoNo?.toString() })
      .then((value) => {
        const inputData: B020010InputData = {
          // 参照モードに設定
          editKbn: editKbn.reference,
          uriage: value.data,
        };
        setSearchedFields({ searched: true, fields: methods.getValues() });
        setMenuNavigate("next");
        navigate("/b020010", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 入金入力画面への遷移処理
  const handleNyukinNavigate = () => {
    B030050Find({
      nyukindenpyoNo: rowData!.denpyoNo!.toString(),
    })
      .then((value) => {
        const inputData: B030050InputData = {
          nyukin: value.data,
          editKbn: editKbn.update,
        };
        if (
          inputData.nyukin[0].seikyushimeYmd &&
          inputData.nyukin[0].seikyushimeNo
        ) {
          inputData.editKbn = editKbn.reference;
        }
        setSearchedFields({ searched: true, fields: methods.getValues() });
        setMenuNavigate("next");
        navigate("/b030050", { state: inputData });
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // テーブル行クリックイベント
  const handleSelectRow = (_: any, rowData: Data | undefined) => {
    setRowData(undefined);
    setRowData(rowData);
    setDisabledDetailButton(false);
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="得意先元帳照会"
          gridTemplateColumns="7rem 2rem 2rem 3rem 8rem 9rem 6rem 7rem 8rem 2rem 5rem 3rem 3rem 5rem 9rem "
        >
          <SLabel required> 対象年月</SLabel>
          <SNumberField
            name="urikakeYm"
            label="対象年月"
            code
            required
            gridColumn="span 3"
            size={6}
            {...register(1)}
          />
          <SText align="left">月度</SText>

          <SLabel required gridColumn="7">
            取引先区分
          </SLabel>
          <SCodeSelect
            name="torihikiKbn"
            label="取引先区分"
            options={B030070TorihikisakiKbn}
            required
            {...register(2)}
          />

          <SLabel required gridColumn="11">
            取引先
          </SLabel>
          <SNumberField
            name="urikakeCd"
            code
            size={6}
            gridColumn="span 2"
            onBlur={() => B000150TokuiNmrUrikakeCd(methods, navigate, setMsg)}
            {...register(3)}
          />
          <SNumberField
            name="urikakeshitenCd"
            code
            size={4}
            dialog={
              <B000150 calledParam={methods.watch("torihikiKbn.value")} />
            }
            handleSubmit={(data: any) => {
              methods.setValue("urikakeCd", data.tokuiCd);
              methods.setValue("urikakeshitenCd", data.tokuishitenCd);
              methods.setValue("tokuiNmr", data.tokuiNmr);
            }}
            onBlur={() => B000150TokuiNmrUrikakeCd(methods, navigate, setMsg)}
            {...register(4)}
          />
          <STextField name="tokuiNmr" size={24} disabled />

          <SLabel gridColumn="1">売掛担当者</SLabel>
          <STextField gridColumn="span 3" name="shainCd" disabled />
          <STextField name="shainNm" disabled />

          <SLabel gridColumn="7">TEL</SLabel>
          <STextField gridColumn="span 2" name="telNo" disabled />

          <SLabel gridColumn="11">FAX</SLabel>
          <STextField name="faxNo" disabled gridColumn="span 3" />

          <SLabel gridColumn="1">締日・回収日</SLabel>
          <STextField name="shimeD" disabled />
          <STextField name="kaishuyoteiD" disabled />

          <SLabel gridColumn="11">回収条件</SLabel>
          <STextField name="kaishuKbn" disabled />

          <SLabel gridColumn="1">取引先分類</SLabel>
          <STextField name="tokuibunNm1" disabled gridColumn="span 4" />
          <STextField name="tokuibunNm2" disabled gridColumn="span 2" />
          <STextField name="tokuibunNm3" disabled gridColumn="span 2" />

          <SNormalButton
            label={labels.buttons.search}
            onClick={handleClickSearchButton}
            align="right"
            gridColumn="15"
            {...register(5)}
          />

          <SText gridColumn="1"></SText>
          <STextField name="tokuibunNm4" disabled gridColumn="span 4" />
          <STextField name="tokuibunNm5" disabled gridColumn="span 2" />
        </SFrame>
      </FormProvider>

      <FormProvider {...shukeiMethods}>
        <SFrame gridTemplateColumns="9rem 9rem 9rem 9rem 9rem 9rem 9rem 9rem ">
          <SLabel>前月売掛残高</SLabel>
          <SLabel>入金額</SLabel>
          <SLabel>売上金額</SLabel>
          <SLabel>返品・値引金額</SLabel>
          <SLabel>外税消費税</SLabel>
          <SLabel>内税消費税</SLabel>
          <SLabel>当月売掛残高</SLabel>
          <SNumberField
            name="zenzanKin"
            disabled
            gridColumn="1"
            align="right"
          />
          <SNumberField name="konkainyuKin" disabled align="right" />
          <SNumberField name="konkaiuriKin" disabled align="right" />
          <SNumberField name="henpinnebikiKin" disabled align="right" />
          <SNumberField name="sotozeiKin" disabled align="right" />
          <SNumberField name="uchizeiKin" disabled align="right" />
          <SNumberField name="urikakezanKin" disabled align="right" />

          <SLabel gridColumn="1">今回入金額(現金)</SLabel>
          <SLabel>今回入金額(振込)</SLabel>
          <SLabel>今回入金額(手形)</SLabel>
          <SLabel>今回入金額(小切手)</SLabel>
          <SLabel>今回入金額(相殺)</SLabel>
          <SLabel>今回入金額(値引)</SLabel>
          <SLabel>今回入金額(手数料)</SLabel>
          <SLabel>今回入金額(その他)</SLabel>
          <SNumberField
            name="genkinnyuKin"
            disabled
            gridColumn="1"
            align="right"
          />
          <SNumberField name="furikominyuKin" disabled align="right" />
          <SNumberField name="tegatanyuKin" disabled align="right" />
          <SNumberField name="kogitenyuKin" disabled align="right" />
          <SNumberField name="sosainyuKin" disabled align="right" />
          <SNumberField name="nebikinyuKin" disabled align="right" />
          <SNumberField name="tesuryoKin" disabled align="right" />
          <SNumberField name="sonotanyuKin" disabled align="right" />

          <SLabel gridColumn="1">今回売上額(売上)</SLabel>
          <SLabel>今回売上額(返品)</SLabel>
          <SLabel>今回売上額(値引)</SLabel>
          <SLabel>今回売上額(その他)</SLabel>
          <SNumberField
            name="headerUriKin"
            disabled
            gridColumn="1"
            align="right"
          />
          <SNumberField name="henpinKin" disabled align="right" />
          <SNumberField name="nebikiKin" disabled align="right" />
          <SNumberField name="sonotauriKin" disabled align="right" />
        </SFrame>

        <SFrame>
          <STable
            keyName="gyoNo"
            data={handleSearch}
            columns={columns}
            tableRef={tableRef}
            onRowClick={handleSelectRow}
            handleDoubleClick={handleShowDatail}
            width={1270}
            height={330}
            onPageChange={handleResetSearch}
          />
        </SFrame>

        <SFrame>
          <SNormalButton
            label={labels.buttons.detail}
            onClick={handleShowDatail}
            disabled={disabledDetailButton}
            align="right"
            {...register(6)}
          />
        </SFrame>
      </FormProvider>
    </>
  );
};
